import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
const NAMES = ['María López', 'Carolina Fernández', 'Lucía Martínez', 'Ana García', 'Valentina Rodríguez', 'Sofía Pérez', 'Camila González', 'Julieta Diaz', 'Martina Silva', 'Florencia Sosa'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerPopup();
    }, 4000);
    const triggerPopup = () => {
      // Random data
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const city = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentData({
        name,
        city
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
        // Schedule next popup (8-12 seconds random delay)
        const nextDelay = Math.floor(Math.random() * 4000) + 8000;
        setTimeout(triggerPopup, nextDelay);
      }, 4000);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-166">
      {isVisible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-4 left-4 z-40 bg-white rounded-lg shadow-xl p-4 max-w-xs border-l-4 border-[#16a34a] flex items-center gap-3" data-id="element-167">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-168">
            <ShoppingCartIcon className="w-5 h-5 text-[#16a34a]" data-id="element-169" />
          </div>
          <div data-id="element-170">
            <p className="text-sm font-bold text-gray-800" data-id="element-171">
              {currentData.name}
            </p>
            <p className="text-xs text-gray-600" data-id="element-172">
              de {currentData.city} acaba de comprar el Kit Completo
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}